angular.module('storefrontApp')
    .component('vcCheckoutWizardStep', {
        templateUrl: 'themes/assets/js/checkout/checkout-wizard-step.tpl.html',
        transclude: true,
        require: {
            wizard: '^vcCheckoutWizard',
        },
        bindings: {
            name: '@',
            title: '@',
            stepDisabled: '=?',
            onNextStep: '&?',
            canEnter: '=?',
            final: '<?',
        },
        controller: [function () {
            const ctrl = this;

            ctrl.components = [];
            ctrl.canEnter = true;

            this.$onInit = function () {
                ctrl.wizard.addStep(this);
            };

            ctrl.addComponent = function (component) {
                ctrl.components.push(component);
            };

            ctrl.removeComponent = function (component) {
                ctrl.components = _.without(ctrl.components, component);
            };

            ctrl.validate = function () {
                return _.every(ctrl.components, function (x) {
                    return !angular.isFunction(x.validate) || x.validate();
                });
            };
        }],
    });
